import { sortBy } from '../../func';

const API_PATH = '/api/languages';

export const languages = {
    namespaced: true,
    state: {
        languages: null,
    },
    mutations: {
        setData(state, value) {
            state.languages = value;
        },
    },
    actions: {
        clearLanguages({ commit }) {
            commit('setData', null);
        },
        async createLanguage({ dispatch, rootGetters }, language) {
            return rootGetters['user/can']('CREATE_LANGUAGES')
                ? await dispatch('api/post', { url: API_PATH, data: language }, { root: true })
                : null;
        },
        async deleteLanguage({ dispatch, rootGetters }, language) {
            return rootGetters['user/can']('DELETE_LANGUAGES')
                ? await dispatch('api/delete', `${API_PATH}/${language.id}`, { root: true })
                : null;
        },
        async getLanguages({ commit, dispatch, rootGetters, state }) {
            if (!state.languages) {
                commit('setData', []);

                rootGetters['user/can']('READ_LANGUAGES') &&
                    commit('setData', (await dispatch('api/get', API_PATH, { root: true })).sort(sortBy('name', 'id')));
            }

            return state.languages;
        },
        async saveLanguage({ dispatch }, language) {
            return await dispatch(language.id ? 'updateLanguage' : 'createLanguage', language);
        },
        async updateLanguage({ dispatch, rootGetters }, language) {
            return rootGetters['user/can']('UPDATE_LANGUAGES')
                ? await dispatch('api/put', { url: `${API_PATH}/${language.id}`, data: language }, { root: true })
                : null;
        },
        logout({ dispatch }) {
            dispatch('clearLanguages');
        },
    }
};

export default languages;